import React, { useEffect, useState } from 'react';
import { Container, Modal } from 'react-bootstrap';
import 'aos/dist/aos.css';
import AOS from 'aos';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import '../styles/Testimonial.css';
import Tilt from 'react-parallax-tilt';
import { FaQuoteLeft } from 'react-icons/fa';

const testimonials = [
  {
    text: "Aligned Vertical provided us with robust network architecture that significantly enhanced our scalability and security across multiple branches.",
    image: "/images/L&T.png",
    company: "L&T "
  },
  {
    text: "With Aligned Vertical custom web solutions, we streamlined our operations and improved user engagement across platforms.",
    image: "/images/tata.png",
    company: "Tata Communications U.S.A" 
  },
  {
    text: "Aligned Vertical transformed our legacy IT infrastructure into a fast, reliable, and cost-efficient system tailored to our needs.",
    image: "/images/Tdc.png",
    company: "TDC NET Denmark"
  },
  {
    text: "Aligned Vertical helped us navigate the complexities of large-scale IT deployments with ease and expertise.",
    image: "/images/ericsson.png",
    company: "Ericsson Italy"
  },
  {
    text: "Exceptional support and customizations by aligned vertical gave us a real edge in IT modernization.",
    image: "/images/adani power.png",
    company: "Adani Power Plant"
  },
  {
    text: "Reliable partners for network transformations with great after-support.",
    image: "/images/stc.png",
    company: "STC Saudi Arabia"
  },
  {
    text: "Aligned Vertical empowered our organization with tools that boost efficiency and lower costs.",
    image: "/images/claro.png",
    company: "Claro Brazil"
  }
];

function Testimonials() {
  const [modalShow, setModalShow] = useState(false);
  const [activeTestimonial, setActiveTestimonial] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const openModal = (item) => {
    setActiveTestimonial(item);
    setModalShow(true);
  };

  return (
    <section className="py-5 bg-light" id="testimonials">
      <Container>
        <h2 className=" testimonial-heading text-center fw-bold mb-5 ">Client Testimonials</h2>
        <Swiper
          modules={[Autoplay, Pagination]}
          slidesPerView={1}
          spaceBetween={30}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          loop={true}
          breakpoints={{
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 }
          }}
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <Tilt glareEnable={true} glareMaxOpacity={0.2} glareColor="#ffffff" glarePosition="all">
                <div
                  className="testimonial-card shadow-sm p-4 bg-white rounded-4 glass"
                  data-aos="fade-up"
                  data-aos-delay={index * 150}
                  onClick={() => openModal(item)}
                >
                  <FaQuoteLeft className="quote-icon mb-2" />
                  <img
                    src={item.image}
                    alt="Client"
                    className="testimonial-img mb-3"
                    style={{ width: '120px', height: '120px' }}
                  />
                  <h6 className="text-primary fw-bold mb-2">{item.company}</h6>
                  <p className="testimonial-text text-muted fst-italic">"{item.text}"</p>
                </div>
              </Tilt>
            </SwiperSlide>
          ))}
        </Swiper>

        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          centered
          className="custom-modal"
        >
         <Modal.Body className="p-3 text-center position-relative modal-content-custom">
  <button
    className="modal-close-btn"
    onClick={() => setModalShow(false)}
    aria-label="Close"
  >
    &times;
  </button>

  {activeTestimonial && (
    <>
      <img
        src={activeTestimonial.image}
        alt="Company"
        style={{ maxWidth: '90px', marginBottom: '1rem' }}
      />
      <h5>{activeTestimonial.company}</h5>
      <p className="fst-italic mt-3">{activeTestimonial.text}</p>
    </>
  )}
</Modal.Body>

        </Modal>
      </Container>
    </section>
  );
}

export default Testimonials;
